// VH-228 phase 0: tone → Tailwind classes for stored documents (light palette; print keeps the colours).

export const ROW_STRIPE = {
  crit: 'border-l-red-600',
  warn: 'border-l-amber-500',
  ok: 'border-l-emerald-600',
  info: 'border-l-teal-600',
  null: 'border-l-gray-300',
  highlight: 'border-l-teal-600',
  neutral: 'border-l-transparent',
}

export const ROW_BG = { highlight: 'bg-teal-50', null: 'text-gray-500' }

export const CHIP = {
  crit: 'bg-red-100 text-red-800',
  warn: 'bg-amber-100 text-amber-900',
  ok: 'bg-emerald-100 text-emerald-800',
  info: 'bg-teal-100 text-teal-800',
  null: 'bg-gray-100 text-gray-600',
  highlight: 'bg-teal-100 text-teal-800',
  neutral: 'bg-gray-100 text-gray-700',
}

export const CALLOUT = {
  crit: 'border-red-600 bg-red-50',
  warn: 'border-amber-500 bg-amber-50',
  ok: 'border-emerald-600 bg-emerald-50',
  info: 'border-teal-600 bg-teal-50',
  null: 'border-gray-300 bg-gray-50',
  highlight: 'border-teal-600 bg-teal-50',
  neutral: 'border-gray-300 bg-surface-container',
}

export const CELL = { up: 'text-red-700 font-semibold', down: 'text-emerald-700 font-semibold', null: 'text-gray-500 italic' }

export const STROKE = {
  crit: 'stroke-red-600',
  warn: 'stroke-amber-600',
  ok: 'stroke-emerald-600',
  info: 'stroke-teal-600',
  null: 'stroke-gray-400',
  highlight: 'stroke-teal-600',
  neutral: 'stroke-gray-800',
}

export const FILL = {
  crit: 'fill-red-600',
  warn: 'fill-amber-600',
  ok: 'fill-emerald-600',
  info: 'fill-teal-600',
  null: 'fill-gray-400',
  highlight: 'fill-teal-600',
  neutral: 'fill-gray-800',
}

export const pick = (map, tone) => map[tone] ?? map.neutral ?? ''
